import React from 'react';
import { WidgetCardProps } from './types';

export const WidgetCard: React.FC<WidgetCardProps> = ({
    title,
    value,
    icon = 'DOC',
    subtitle,
    size = 'sm',
    themeColors
}) => {
    const sizeConfig = {
        sm: { padding: '12px 16px', minHeight: 90, valueSize: 22, iconSize: 36, iconFont: 12 },
        md: { padding: '16px 18px', minHeight: 110, valueSize: 26, iconSize: 40, iconFont: 13 },
        lg: { padding: '20px 20px', minHeight: 140, valueSize: 32, iconSize: 46, iconFont: 14 }
    }[size];

    return (
        <div style={{
            backgroundColor: themeColors.cardBackground,
            borderRadius: 8,
            padding: sizeConfig.padding,
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            border: `1px solid ${themeColors.cardBorder}`,
            display: 'flex',
            flexDirection: 'column',
            gap: 6,
            minHeight: sizeConfig.minHeight
        }}>
            <div style={{
                fontSize: 11,
                color: themeColors.textSecondary,
                fontWeight: 500,
                display: 'flex',
                alignItems: 'center',
                gap: 3
            }}>
                {title}
            </div>

            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 12
            }}>
                <div style={{
                    fontSize: sizeConfig.valueSize,
                    fontWeight: 700,
                    color: themeColors.text,
                    lineHeight: 1.2
                }}>
                    {typeof value === 'number' ? value.toLocaleString() : value}
                </div>

                <div style={{
                    width: sizeConfig.iconSize,
                    height: sizeConfig.iconSize,
                    borderRadius: '50%',
                    backgroundColor: themeColors.buttonHover,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: sizeConfig.iconFont,
                    fontWeight: 700,
                    color: themeColors.textSecondary
                }}>
                    {icon}
                </div>
            </div>

            {subtitle && (
                <div style={{
                    fontSize: 11,
                    color: themeColors.textSecondary,
                    marginTop: 2
                }}>
                    {subtitle}
                </div>
            )}
        </div>
    );
};
